import { campaignsClient } from 'clients/CampaignsClient/CampaignsClient';
import { usePageContext } from 'hooks/shared/usePageContext';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { SnackbarContext } from 'shared/legacy/contexts/SnackbarContext/SnackbarContext';
import { useGetAllAtsConnectionsQuery } from 'shared/legacy/hooks/useGetAllAtsConnectionsQuery';
import { useCandidateAction, WrappedHookParams } from './useCandidateAction';

export const useResendAts = (params: WrappedHookParams) => {
  const { createSnackbar } = useContext(SnackbarContext);
  const { dictionary } = useContext(LocalizationContext);
  const pageContext = usePageContext();
  const { data: atsConnections } = useGetAllAtsConnectionsQuery();

  return useCandidateAction<void>(
    async ({ candidate }) =>
      campaignsClient.postApproveCampaignCandidate({
        campaignId: candidate.campaignId as number,
        candidateId: candidate.es_person_id,
      }),
    {
      onSuccess: ({ fcParams: { candidate }, gtm }) => {
        gtm.candidateSentToATS(candidate.campaignId, candidate.es_person_id, pageContext);

        const atsName = atsConnections?.activeATS?.name || dictionary.yourAts;
        const candidateFirstName = candidate.firstName || dictionary.theCandidate;

        createSnackbar(dictionary.candidateSentToAts(candidateFirstName, atsName), {
          variant: 'success',
          title: dictionary.sentToAts,
        });
      },
    },
  )(params);
};
